var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1803 8.77561C25.0187 8.28765 24.5754 7.94108 24.0509 7.89493L16.9267 7.26338L14.1096 0.825992C13.9019 0.354215 13.4288 0.0488281 12.9032 0.0488281C12.3776 0.0488281 11.9045 0.354215 11.6968 0.827095L8.87971 7.26338L1.75435 7.89493C1.23082 7.94218 0.788637 8.28765 0.626115 8.77561C0.463593 9.26356 0.613686 9.79877 1.00973 10.1361L6.3948 14.7469L4.80686 21.5759C4.69067 22.078 4.89029 22.5971 5.31703 22.8982C5.54641 23.06 5.81476 23.1424 6.08538 23.1424C6.31871 23.1424 6.55016 23.081 6.75788 22.9596L12.9032 19.3739L19.0463 22.9596C19.4958 23.2237 20.0625 23.1996 20.4883 22.8982C20.9152 22.5961 21.1146 22.0769 20.9984 21.5759L19.4105 14.7469L24.7956 10.1371C25.1916 9.79877 25.3428 9.26448 25.1803 8.77561V8.77561Z",
    fill: "#27D639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingFilled);
export default __webpack_public_path__ + "static/media/ratingFilled.4601e7712569d0884592fcda49b7dd9a.svg";
export { ForwardRef as ReactComponent };